import { nonNull } from '@helpers/non-null';

async function traverseFileTree(item: FileSystemEntry): Promise<File[]> {
  if (item.isFile) {
    return new Promise((resolve) => {
      (item as FileSystemFileEntry).file(
        (file) => resolve([file]),
        (err) => {
          console.error(err);
          resolve([]);
        }
      );
    });
  }
  if (item.isDirectory) {
    const dirReader = (item as FileSystemDirectoryEntry).createReader();
    return new Promise((resolve) => {
      dirReader.readEntries(
        async (entries) => {
          const result: File[] = [];
          for (let i = 0; i < entries.length; i++) {
            result.push(...(await traverseFileTree(entries[i])));
          }
          resolve(result);
        },
        (err) => {
          console.error(err);
          resolve([]);
        }
      );
    });
  }
  return [];
}

export async function getFiles(
  items:
    | File
    | File[]
    | FileList
    | DataTransferItem
    | DataTransferItem[]
    | DataTransferItemList
): Promise<File[]> {
  return (
    await Promise.all(
      (items instanceof File
        ? [items]
        : items instanceof DataTransferItem
        ? [items]
        : Array.isArray(items)
        ? items
        : new Array(items.length)
            .fill(undefined)
            .map((_, i) => nonNull(items[i]))
      ).map((x) => {
        if (x instanceof File) return x;
        if (x.kind !== 'file') return null;
        if ('webkitGetAsEntry' in x) {
          const entry = x.webkitGetAsEntry();
          if (entry?.isDirectory) {
            return traverseFileTree(entry);
          }
        }
        return x.getAsFile();
      })
    )
  )
    .filter((x) => !!x)
    .flatMap((x) => nonNull(x))
    .filter((x) => x.size > 0);
}
